import { type ReactNode } from 'react'
import { motion } from 'framer-motion'
import { cn } from 'src/shared/components/ui/utils'

const fadeInitial = { opacity: 0, y: 24 }
const fadeRest = { opacity: 1, y: 0 }
const fadeTransition = { duration: 0.75, ease: [0.22, 1, 0.36, 1] as const }

/** Fade + lift on first paint (e.g. hero above the fold). */
export const FadeInOnMount = ({
  className,
  children,
}: {
  className?: string
  children?: ReactNode
}) => {
  return (
    <motion.div
      className={cn('w-full', className)}
      initial={fadeInitial}
      animate={fadeRest}
      transition={fadeTransition}
    >
      {children}
    </motion.div>
  )
}

/** Fade + lift when the block scrolls into view. */
export const FadeInSection = ({
  className,
  children,
}: {
  className?: string
  children?: ReactNode
}) => {
  return (
    <motion.div
      className={cn('w-full', className)}
      initial={fadeInitial}
      whileInView={fadeRest}
      viewport={{
        once: true,
        amount: 0.05,
        margin: '0px 0px -96px 0px',
      }}
      transition={fadeTransition}
    >
      {children}
    </motion.div>
  )
}
